import { PayloadAction } from '@reduxjs/toolkit';
import isEqual from 'lodash/isEqual';
import omit from 'lodash/omit';
import { put, takeLatest, select } from 'redux-saga/effects';
import { Task } from 'api/tasks';
import { FetchStatus } from 'data/core';
import { saveTaskDetailSaga } from 'data/tasks/actions';
import { taskNormalizer } from 'data/tasks/schema';
import {
  saveNormalizedTask,
  saveNormalizedPartialTasks,
} from 'data/tasks/slice';

function* saveTaskDetail({ payload }: PayloadAction<Task>): Generator {
  const task = payload;
  const {
    entities: { tasks },
  } = taskNormalizer(task);

  if (tasks) {
    const actualTaskResult = tasks[task.taskId];

    if (actualTaskResult) {
      const existingTask = yield select(
        (state) => state.tasks.items[task.taskId],
      );

      if (!isEqual(actualTaskResult, existingTask)) {
        const actualTask = {
          [actualTaskResult.taskId]: actualTaskResult,
        };

        yield put(
          saveNormalizedTask({
            data: actualTask,
            fetchStatus: FetchStatus.Loaded,
          }),
        );
      }
    }

    const subtasks = omit(tasks, task.taskId);

    yield put(saveNormalizedPartialTasks(subtasks));
  }
}

export const watchSaveTaskDetailSaga = function* (): Generator {
  yield takeLatest(saveTaskDetailSaga.type, saveTaskDetail);
};
